import { type RefObject, useState } from 'react';
import { useDebounceCallback, useResizeObserver } from 'usehooks-ts';

type Size = {
  width?: number;
  height?: number;
};

export function useElementSize(ref: RefObject<HTMLElement | null>, delay = 200) {
  const [{ width, height }, setSize] = useState<Size>({
    height: undefined,
    width: undefined,
  });

  const onResize = useDebounceCallback(setSize, delay);

  useResizeObserver({
    box: 'border-box',
    onResize,
    // usehooks-ts still types ref as non-null; React 19 refs are RefObject<T | null>
    ref: ref as RefObject<HTMLElement>,
  });

  return { height, width };
}
